/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 */

import React from 'react';
import '../../form-elements/formElement.css';
import API from "../../../../../utils/api";
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import axios from 'axios';
import FormElementGenerator from "../../form-elements/formElementGenerator";
import Loader from "../../../loader/loader";
import {toIntFlag} from "../../../../../utils/formValueUtils";

/**
 * HOC for the partner form
 */
class LmsForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            lmsId: null,
            lmsName: '',
            lmsBaseUrl: '',
            // partner dropdown
            enabled:'',
            enabledName: '',
            disabledUrl: '',
            routingId: '',
            targetId: '',
            pluginType: '',
            macKey: '',
            userName: null,
            userPswrd: null,
            // partner url type dropdown
            autoShutdown: '',
            autoShutdownName: '',
            isDisplayLoader: true,
            errors: {},

            token: '',
            fields: [
                {
                    inputType: 'text',
                    labelName: 'Name *',
                    inputName: 'lmsName',
                    placeholder: 'Please enter LMS Name here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'textUrl',
                    labelName: 'Base Url *',
                    inputName: 'lmsBaseUrl',
                    placeholder: 'Please enter base url here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'textUrl',
                    labelName: 'Disabled Url *',
                    inputName: 'disabledUrl',
                    placeholder: 'Please enter disabled url here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'text',
                    labelName: 'Routing Id *',
                    inputName: 'routingId',
                    placeholder: 'Please enter Routing Id here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'text',
                    labelName: 'Target Id *',
                    inputName: 'targetId',
                    placeholder: 'Please enter Target Id here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'text',
                    labelName: 'Plugin Type *',
                    inputName: 'pluginType',
                    placeholder: 'Please enter Plugin Type here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'dropdown',
                    labelName: 'Enabled *',
                    // initial attribute (the value name of the selected option in the dropdown)
                    inputName: 'enabled',
                    optionValueName: 'enabled',
                    optionLabelName: 'enabledName',
                    required: true,
                    path: null,
                    valueType: 'basic'
                },
                {
                    inputType: 'dropdown',
                    labelName: 'Auto Shutdown *',
                    // initial attribute (the value name of the selected option in the dropdown)
                    inputName: 'autoShutdown',
                    optionValueName: 'autoShutdown',
                    optionLabelName: 'autoShutdownName',
                    required: true,
                    path: null,
                    valueType: 'basic'
                },
                {
                    inputType: 'text',
                    labelName: 'Mac Key',
                    inputName: 'macKey',
                    placeholder: 'Please enter Mac Key here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'text',
                    labelName: 'Username',
                    inputName: 'userName',
                    placeholder: 'Please enter Username here',
                    value: '',
                    required: true,
                    disabled: false
                },
                {
                    inputType: 'textPassword',
                    labelName: 'Password',
                    inputName: 'userPswrd',
                    placeholder: 'Please enter Password here',
                    value: '',
                    required: true,
                    disabled: false
                }
            ]
        };

        // get the parameter from URL
        const lmsId = this.props.match.params.id;

        // set icons to the header
        if (lmsId === undefined) {
            EventEmitter.emit('setPageHeaderData', {
                page: 'lms',
                pageName: "LMS",
                pageLink: process.env.REACT_APP_BASE_URL + "/#/home/lms",
                optionalIcons: ['backIcon','clearFormIcon']
            });
        } else {
            EventEmitter.emit('setPageHeaderData', {
                page: 'lms',
                pageName: "LMS",
                pageLink: process.env.REACT_APP_BASE_URL + "/#/home/lms",
                optionalIcons: ['backIcon','clearFormIcon','deleteIcon']
            });
        }

        // set the event emitters
        EventEmitter.on('saveFormData', this.handleSubmit);
        EventEmitter.on('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.on('deleteFormData', this.deletePartnerUrl);
        EventEmitter.on('navigateToPreviousPage', this.navigateToPreviousPage);
        EventEmitter.on('clearForm', this.clearForm);
    }

    // set a token to unsubscribe the async call
    CancelToken = axios.CancelToken;
    source = this.CancelToken.source();

    componentDidMount = async () => {
        // get parameter from URL
        const lmsId = this.props.match.params.id;

        // get token
        const user = JSON.parse(localStorage.getItem('tmcUser'));
        const token = 'Bearer ' + user.token;

        const oldState = Object.assign({}, this.state);

        // fill the form if not a create partner
        if (lmsId !== undefined) {

            const url = '/lms?search=%7BlmsId:' + lmsId + '%7D';

            await API.get(url, {headers: {Authorization: token}, cancelToken: this.source.token})
                .then(res => {
                    const data = res.data[0];
                    oldState.lmsId = (data.lmsId !== undefined) ? data.lmsId : null;
                    oldState.lmsName = (data.lmsName !== undefined) ? data.lmsName : null;
                    oldState.lmsBaseUrl = (data.lmsBaseUrl !== undefined) ? data.lmsBaseUrl : '';
                    oldState.enabled = (data.enabled !== undefined) ? data.enabled : '';
                    oldState.enabledName = (data.enabled) ? 'Yes' : 'No';
                    oldState.disabledUrl = (data.disabledUrl !== undefined) ? data.disabledUrl : '';
                    oldState.routingId = (data.routingId !== undefined) ? data.routingId : '';
                    oldState.targetId = (data.targetId !== undefined) ? data.targetId : '';
                    oldState.pluginType = (data.pluginType !== undefined) ? data.pluginType : '';
                    oldState.macKey = (data.macKey !== undefined) ? data.macKey : '';
                    oldState.userName = (data.userName !== undefined) ? data.userName : '';
                    oldState.userPswrd = (data.userPswrd !== undefined) ? data.userPswrd : '';
                    oldState.autoShutdown = (data.autoShutdown !== undefined) ? data.autoShutdown : '';
                    oldState.autoShutdownName = (data.autoShutdown) ? 'Yes' : 'No';
                    oldState.token = token;
                    oldState.isDisplayLoader = false;

                    this.setState(oldState);
                }).catch(err => {
                    oldState.isDisplayLoader = false;
                    this.setState(oldState);
                    this.displayErrorsForAPICalls(err);
                });
        } else {
            oldState.token = token;
            oldState.isDisplayLoader = false;
            this.setState(oldState);
        }
    };

    componentWillUnmount = () => {
        // remove all event emitters
        EventEmitter.off('setPageHeaderData', {});
        EventEmitter.off('saveFormData', this.handleSubmit);
        EventEmitter.off('displayDeleteFormDataWarning', this.displayDeleteWarningMessage);
        EventEmitter.off('deleteFormData', this.deletePartnerUrl);
        EventEmitter.off('navigateToPreviousPage', this.navigateToPreviousPage);
        EventEmitter.off('clearForm', this.clearForm);
        this.source.cancel("cancel lms async calls");
    };

    /**
     * set the state
     * @param event
     */
    handleChange = event => {
        if (event.optionValueName !== undefined) {
            this.setState({
                [event.optionValueName]: event.value,
                [event.optionLabelName]: event.label
            }, () => {
                this.validate(event.optionValueName, event.value)
            });
        } else {
            const key = event.currentTarget.name;
            const val = event.currentTarget.value;

            this.setState({
                [key]: val
            }, () => {
                this.validate(key, val)
            });
        }
    };

    /**
     * handle the form submission
     */
    handleSubmit = () => {
        // data to be sent
        let data = null;
        // check its a update or create
        if (this.state.lmsId !== null) {
            data = {
                lmsId: this.state.lmsId,
                lmsName: this.state.lmsName,
                lmsBaseUrl: this.state.lmsBaseUrl,
                enabled: toIntFlag(this.state.enabled),
                disabledUrl: this.state.disabledUrl,
                routingId: this.state.routingId,
                targetId: this.state.targetId,
                pluginType: this.state.pluginType,
                macKey: this.state.macKey,
                userName: this.state.userName,
                userPswrd: this.state.userPswrd,
                autoShutdown: toIntFlag(this.state.autoShutdown)
            };
        } else {
            data = {
                lmsName: this.state.lmsName,
                lmsBaseUrl: this.state.lmsBaseUrl,
                enabled: toIntFlag(this.state.enabled),
                disabledUrl: this.state.disabledUrl,
                routingId: this.state.routingId,
                targetId: this.state.targetId,
                pluginType: this.state.pluginType,
                macKey: this.state.macKey,
                userName: this.state.userName,
                userPswrd: this.state.userPswrd,
                autoShutdown: toIntFlag(this.state.autoShutdown)
            };
        }

        // validate each form field
        for (let [key, value] of Object.entries(data)) {
            this.validate(key, value);
        }

        // check weather there are error messages
        if (Object.values(this.state.errors).find(o => o !== '') === undefined) {
            // check update or create
            if (this.state.lmsId !== null) {
                this.updateLms(data);
            } else {
                this.createLms(data);
            }
        }
    };

    /**
     * validate the user inputs
     * @param key - input name
     * @param value - input value
     */
    validate = (key, value) => {
        let error = {};

        switch (key) {
            case 'lmsName':
                if (value === '')
                    error[key] = "LMS Name is Required!";
                else if (value === ' ')
                    error[key] = "LMS Name can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 32))
                    error[key] = "LMS Name can't have more than 32 characters!";
                else
                    error[key] = "";
                break;
            case 'lmsBaseUrl':
                if (value === '')
                    error[key] = "Base URL is Required!";
                else if (value === ' ')
                    error[key] = "Base URL can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 128))
                    error[key] = "Base URL can't have more than 128 characters!";
                else if ((value.indexOf("https://") === 0) || (value.indexOf("http://") === 0) || (value.indexOf("/") === 0))
                    error[key] = "";
                else
                    error[key] = "Base URL must begin with with http://, https:// or / ";
                break;
            case 'disabledUrl':
                if (value === '')
                    error[key] = "Disabled URL is Required!";
                else if (value === ' ')
                    error[key] = "Disabled URL can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 128))
                    error[key] = "Disabled URL can't have more than 128 characters!";
                else if ((value.indexOf("https://") === 0) || (value.indexOf("http://") === 0) || (value.indexOf("/") === 0))
                    error[key] = "";
                else
                    error[key] = "Disabled URL must begin with with http://, https:// or / ";
                break;
            case 'routingId':
                if (value === '')
                    error[key] = "Routing Id is Required!";
                else if (value === ' ')
                    error[key] = "Routing Id can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 32))
                    error[key] = "Routing Id can't have more than 32 characters!";
                else
                    error[key] = "";
                break;
            case 'targetId':
                if (value === '')
                    error[key] = "Target Id is Required!";
                else if (value === ' ')
                    error[key] = "Target Id can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 32))
                    error[key] = "Target Id can't have more than 32 characters!";
                else
                    error[key] = "";
                break;
            case 'pluginType':
                if (value === '')
                    error[key] = "Plugin Type is Required!";
                else if (value === ' ')
                    error[key] = "Plugin Type can't be an empty space!";
                else if ((new TextEncoder().encode(value).length > 32))
                    error[key] = "Plugin Type can't have more than 32 characters!";
                else
                    error[key] = "";
                break;
            case 'enabled':
                // if (this.state.enabled === '')
                //     error[key] = "Please select an enabled!";
                // else
                    error[key] = "";
                break;
            case 'autoShutdown':
                // if (this.state.autoShutdown === '')
                //     error[key] = "Please select an Auto Shutdown!";
                // else
                    error[key] = "";
                break;
            case 'userName':
                if ((new TextEncoder().encode(value)).length > 32)
                    error[key] = "Username can't have more than 32 characters!";
                else
                    error[key] = "";
                break;
            case 'userPswrd':
                if ((new TextEncoder().encode(value)).length > 64)
                    error[key] = "Password can't have more than 64 characters!";
                else
                    error[key] = "";
                break;
            default:
                break;
        }

        const newState = Object.assign({}, this.state);
        newState.errors = Object.assign(newState.errors, error);

        this.setState(newState);
    };

    /**
     * create lms
     * @param data - the data to create a new lms
     */
    createLms = async (data) => {
        await API.post('/lms',
            {
                "lmsName": data.lmsName,
                "lmsBaseUrl": data.lmsBaseUrl,
                "enabled": data.enabled ? 1 : 0,
                "disabledUrl": data.disabledUrl,
                "routingId": data.routingId,
                "targetId": data.targetId,
                "pluginType": data.pluginType,
                "macKey": data.macKey,
                "userName": data.userName === '' ? null : data.userName, // Set to null if empty string
                "userPswrd": data.userPswrd === '' ? null : data.userPswrd, // Set to null if empty string
                "autoShutdown": data.autoShutdown ? 1 : 0
            }, {headers: {Authorization: this.state.token}, cancelToken: this.source.token}
        ).then(res => {
            this.setAlert("Success", "Success", "Successfully Created the LMS");
            this.props.history.push('/home/lms');
        }).catch(er => {
            this.displayErrorsForAPICalls(er);
        });
    };

    /**
     * update lms
     * @param data - updated lms details
     */
    updateLms = async (data) => {
        await API.put('/lms',
            {
                "lmsId": data.lmsId,
                "lmsName": data.lmsName,
                "lmsBaseUrl": data.lmsBaseUrl,
                "enabled": data.enabled ? 1 : 0,
                "disabledUrl": data.disabledUrl,
                "routingId": data.routingId,
                "targetId": data.targetId,
                "pluginType": data.pluginType,
                "macKey": data.macKey,
                "userName": data.userName === '' ? null : data.userName,
                "userPswrd": data.userPswrd === '' ? null : data.userPswrd,
                "autoShutdown": data.autoShutdown ? 1 : 0
            },{headers: {Authorization: this.state.token}, cancelToken: this.source.token}
        ).then(response => {
            this.setAlert("Success", "Success", "Successfully updated the LMS");
            this.props.history.push('/home/lms');
        }).catch(er => {
            this.displayErrorsForAPICalls(er);
        });
    };

    /**
     * display delete warning message
     */
    displayDeleteWarningMessage = () => {
        if (this.state.lmsId !== null) {
            EventEmitter.emit('warningModelData', {
                type: 'lms',
                name: this.state.lmsName
            });
            EventEmitter.emit('openWarningModel', true);
        } else {
            EventEmitter.emit('setAlert', {
                openAlert: true,
                type: "Error",
                isDisplayAlertIcon: true,
                alertMessage: "You are trying to delete before loading the LMS Details",
                alertTitle: "Error"
            });
        }

    };

    /**
     * delete a partner
     * @param data
     */
    deletePartnerUrl = async (data) => {
        if (data && (this.props.match.path === "/home/lms/:id")) {
            await API.delete('/lms?lmsId=' + this.state.lmsId, {headers: {Authorization: this.state.token}, cancelToken: this.source.token})
                .then(res => {
                    this.setAlert("Success", "Success", "Successfully Deleted the LMS");
                    this.props.history.push('/home/lms');
                }).catch(er => {
                    this.displayErrorsForAPICalls(er);
                });
        }
    };

    displayErrorsForAPICalls = (error) => {
        if (error.response !== undefined && error.response.status === 404) {
            this.setAlert("Error", "Error", "The selected item not found!");
        } else if (error.message.includes('422')) {
            this.setAlert("Error", "Sorry", "LMS name & Target Id must be unique!");
        } else if (error.response === undefined || error.response.status === 401) {
            localStorage.removeItem('tmcUser')
            this.props.history.push('/');
        } else {
            this.setAlert("Error", "Error", "Something went wrong");
        }
    };

    /**
     * fire an alert
     * @param alertType
     * @param alertTitle
     * @param alertMessage
     */
    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    /**
     * clear the form
     */
    clearForm = () => {
        const newState = Object.assign({}, this.state);

        newState.lmsName = "";
        newState.lmsBaseUrl = "";
        newState.enabled = "";
        newState.enabledName = "";
        newState.disabledUrl = "";
        newState.routingId = "";
        newState.targetId = "";
        newState.pluginType = "";
        newState.macKey = "";
        newState.userName = "";
        newState.userPswrd = "";
        newState.autoShutdown = "";
        newState.autoShutdownName = "";
        newState.errors = {};

        this.setState(newState);
    };

    /**
     * navigate to previous page
     */
    navigateToPreviousPage = () => {
        this.props.history.push('/home/lms');
    };

    render() {
        return(
            <div role="form" className="container">
                {this.state.isDisplayLoader && <Loader/>}
                <div className="main-btn-container">
                    <div className="buttons" tooltip="Save" onClick={this.handleSubmit}>
                        <i className="fa fa-save fa-lg icon-primary" />
                    </div>
                </div>
                <form>
                    <FormElementGenerator currentState={this.state} handleChange={this.handleChange} />
                </form>
            </div>
        )
    }
}

export default LmsForm;
